import { useLogger } from "Services/logging/logger/useLogger";

export interface LogoutHandlerParams {
	absoluteAction: string;
	bookingUrl: string;
	culture: string;
}

export const useLogoutHandler = (params: LogoutHandlerParams) => {
	const { logEvent } = useLogger();

	const handleLogout = () => {
		logEvent("user_logout", {});
		const url = `${params.bookingUrl}/Member/Logout?culture=${params.culture}&url=${params.absoluteAction}`;
		window.setTimeout(() => (window.location.href = url), 500);
	};

	return { handleLogout };
};
